import ShortCutDisplay from "../../../../src/components/ShortcutDisplay";
import helpercontextmenu from "../../../../assets/images/docs/helper/context-menu.png";
import helpericon from "../../../../assets/images/docs/helper/helpericon.png";
import helperbutton from "../../../../assets/images/docs/helper/button.png";
import helperbutton2 from "../../../../assets/images/docs/helper/button2.png";
import browserextension from "../../../../assets/images/docs/browserextension.png";
import helperbutton3 from "../../../../assets/images/docs/helper/button3.png";
import helperoptions from "../../../../assets/images/docs/helper/options.png";
import helperoverlay from "../../../../assets/images/docs/helper/overlay.png";
import helperauto from "../../../../assets/images/docs/helper/auto.png";
import * as React from 'react';
export default {
  ShortCutDisplay,
  helpercontextmenu,
  helpericon,
  helperbutton,
  helperbutton2,
  browserextension,
  helperbutton3,
  helperoptions,
  helperoverlay,
  helperauto,
  React
};